export const ADMIN = 'ADMIN';
export const STAFF = 'STAFF';
export const REGISTERED = 'REGISTERED';
export const SUPERADMIN = 'SUPERADMIN';